var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.6065 1.57797L18.3872 16.287C18.1443 17.3251 17.5109 17.5835 16.6108 17.0944L11.7056 13.5925L9.33877 15.7979C9.07684 16.0517 8.85778 16.2639 8.35297 16.2639L8.70538 11.424L17.7967 3.46505C18.1919 3.12362 17.7109 2.93445 17.1823 3.27588L5.94323 10.1321L1.1047 8.66489C0.0522293 8.34653 0.0331798 7.64522 1.32377 7.15615L20.2493 0.0923052C21.1255 -0.226052 21.8923 0.281474 21.6065 1.57797Z","fill":"#6FCF97"}));
}

Telegram.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
